import { InfoContainer } from './base/info-container.component';

export function ErrorPage() {
  return (
    <InfoContainer
      title="Ein Fehler ist aufgetreten"
      description="Bitte versuchen Sie es später erneut oder wenden Sie sich an Ihren Ansprechpartner."
      button={{
        text: 'Zurück zur Startseite',
        href: '/bp/c',
      }}
    />
  );
}
